// extracted by mini-css-extract-plugin
export default {"subheader":"TeamHeader_subheader__dGC3F","spacing":"TeamHeader_spacing__XX--Q","breadcrumbs":"TeamHeader_breadcrumbs__YtjPV"};